import UNSPLASH from './unsplashImages.js';

export const DEMO_SERVICES = [
  {
    id: 'grocery-delivery',
    name: 'Grocery Delivery',
    category: 'PROVISIONS',
    image: UNSPLASH.services.groceryDelivery,
    benefit: 'A fully stocked fridge before you arrive',
    description:
      'Browse 20,000+ products and build your perfect grocery order. We source, deliver, and neatly stage everything in the kitchen before check-in.',
    exampleRequest: 'Family breakfast bundle + sparkling water + fresh fruit bowl.',
    icon: 'ShoppingCart',
  },
  {
    id: 'private-chef',
    name: 'Private Chef',
    category: 'DINING',
    image: UNSPLASH.services.privateChef,
    benefit: 'In-home dining crafted by a local chef',
    description:
      'A professional chef arrives at your rental with fresh ingredients and prepares a multi-course meal tailored to your preferences, dietary needs, and group size.',
    exampleRequest: 'Italian dinner for 4 on Saturday evening, one guest is gluten-free.',
    icon: 'ChefHat',
  },
  {
    id: 'restaurant-reservations',
    name: 'Restaurant Reservations',
    category: 'DINING',
    image: UNSPLASH.services.restaurantReservations,
    benefit: 'Priority tables at the best local spots',
    description:
      'Our concierge team secures reservations at sought-after restaurants, handles special requests, and confirms every detail so you can simply show up.',
    exampleRequest: 'Table for 6, waterfront, Friday 7:30 PM, celebrating a birthday.',
    icon: 'UtensilsCrossed',
  },
  {
    id: 'iv-therapy',
    name: 'IV Therapy',
    category: 'WELLNESS',
    image: UNSPLASH.services.ivTherapy,
    benefit: 'Hydration and vitamins delivered bedside',
    description:
      'A licensed nurse visits your rental and administers a customized IV drip — perfect for recovery, jet lag, or a wellness boost during your stay.',
    exampleRequest: 'Hydration + vitamin C drip, Sunday morning before checkout.',
    icon: 'Droplets',
  },
  {
    id: 'airport-pickup',
    name: 'Airport Transfer',
    category: 'TRANSPORT',
    image: UNSPLASH.services.airportTransfer,
    benefit: 'Stress-free rides to and from the airport',
    description:
      'A private driver meets you at arrivals and takes you directly to the property. Return transfers can be scheduled for checkout day.',
    exampleRequest: 'Pick up at MIA Terminal D, arriving 3:15 PM, party of 3 with luggage.',
    icon: 'Plane',
  },
  {
    id: 'arrival-event',
    name: 'Arrival Event Setup',
    category: 'CELEBRATION',
    image: UNSPLASH.services.arrivalEvent,
    benefit: 'Decorations and surprises waiting at the door',
    description:
      'We stage balloons, banners, flowers, and custom touches before you arrive — ideal for birthdays, proposals, anniversaries, or bachelorette weekends.',
    exampleRequest: 'Rose-gold balloon arch + "Happy 30th" banner + champagne on ice.',
    icon: 'PartyPopper',
  },
  {
    id: 'massage',
    name: 'Massage',
    category: 'WELLNESS',
    image: UNSPLASH.services.massage,
    benefit: 'Licensed therapists come to your rental',
    description:
      'Book a professional massage therapist for an in-room session — deep tissue, Swedish, couples, or prenatal. Equipment and linens provided.',
    exampleRequest: 'Couples deep-tissue massage, 60 min, Saturday at 4 PM.',
    icon: 'Heart',
  },
  {
    id: 'other',
    name: 'Custom Request',
    category: 'CONCIERGE',
    image: UNSPLASH.services.customRequest,
    benefit: 'Anything else — just ask your concierge',
    description:
      'Need something that doesn\'t fit a category? Send a freeform request and our concierge team will coordinate it — from boat rentals to pet sitters.',
    exampleRequest: 'Kayak rental for 2, delivered to the property dock Saturday morning.',
    icon: 'Sparkles',
  },
];

export const CATEGORY_LABELS = {
  DINING: 'Dining',
  WELLNESS: 'Wellness',
  TRANSPORT: 'Transport',
  CELEBRATION: 'Celebration',
  PROVISIONS: 'Provisions',
  CONCIERGE: 'Concierge',
};
